import React from 'react';
import { motion } from 'framer-motion';
const services = [{
  id: '01',
  title: 'Property\nWebsites',
  description: 'Give every listing its own digital presence. Nothing else in the market looks like it.'
}, {
  id: '02',
  title: 'Creative\nProduction',
  description: 'Visuals, copy, and content built specifically for the property. Designed to stop the scroll.'
}, {
  id: '03',
  title: 'Campaign\nLaunch',
  description: 'From brief to live in 48 hours. Your listing presented before the market even opens.'
}, {
  id: '04',
  title: 'Brand &\nIdentity',
  description: 'Visual identity systems for agents and developers who want to look as sharp as the properties they sell.'
}];
export function ServicesSection() {
  return <section id="what" className="py-[48px] sm:py-[64px] md:py-[100px] px-5 sm:px-6 md:px-[48px] border-b border-tux-border bg-tux-dark/70 backdrop-blur-2xl" data-id="element-137">
      <div className="max-w-[1200px]" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="font-mono font-light text-[9px] tracking-[0.36em] uppercase text-tux-muted flex items-center gap-[16px] mb-[28px] sm:mb-[40px]" data-id="element-139">
          What We Do
          <div className="flex-1 h-[1px] bg-tux-border" data-id="element-140" />
        </motion.div>

        <div className="flex flex-col" data-id="element-141">
          {services.map((service, index) => <motion.div key={service.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className={`grid grid-cols-1 md:grid-cols-[220px_1fr] gap-[16px] sm:gap-[20px] md:gap-[48px] py-[32px] sm:py-[44px] border-b border-tux-border items-start ${index === 0 ? 'border-t' : ''}`} data-id="element-142">
              <div className="flex flex-col gap-[10px]" data-id="element-143">
                <div className="font-mono font-light text-[10px] tracking-[0.2em] text-tux-lime opacity-40" data-id="element-144">
                  {service.id}
                </div>
                <h3 className="font-display font-black text-[28px] sm:text-[34px] uppercase text-white tracking-[0.01em] leading-[0.95] whitespace-pre-line" data-id="element-145">
                  {service.title}
                </h3>
              </div>
              <div className="font-sans font-light text-[15px] sm:text-[16px] leading-[1.7] text-white/40 max-w-[540px] md:pt-[28px]" data-id="element-146">
                {service.description}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}